﻿{
  "US": "Estados Unidos",
  "AF": "Afganistán",
  "AX": "Islas Aland",
  "AL": "Albania",
  "DZ": "Argelia",
  "AS": "Samoa Americana",
  "AD": "Andorra",
  "AO": "Angola",
  "AI": "Anguila",
  "AQ": "Antártida",
  "AG": "Antigua y Barbuda",
  "AR": "Argentina",
  "AM": "Armenia",
  "AW": "Aruba",
  "AU": "Australia",
  "AT": "Austria",
  "AZ": "Azerbaiyán",
  "BS": "Bahamas",
  "BH": "Baréin",
  "BD": "Bangladesh",
  "BB": "Barbados",
  "BY": "Belarús",
  "BE": "Bélgica",
  "BZ": "Belice",
  "BJ": "Benín",
  "BM": "Islas Bermudas",
  "BT": "Bután",
  "BO": "Bolivia",
  "BA": "Bosnia y Herzegovina",
  "BW": "Botsuana",
  "BV": "Isla Bouvet",
  "BR": "Brasil",
  "IO": "Territorio Británico del Océano Índico",
  "BN": "Brunéi Darussalam",
  "BG": "Bulgaria",
  "BF": "Burkina Faso",
  "BI": "Burundi",
  "KH": "Camboya",
  "CM": "Camerún",
  "CA": "Canadá",
  "CV": "Cabo Verde",
  "KY": "Islas Caimán",
  "CF": "República Centroafricana",
  "TD": "Chad",
  "CL": "Chile",
  "CN": "China",
  "CX": "Isla de Navidad",
  "CC": "Islas Cocos (Keeling)",
  "CO": "Colombia",
  "KM": "Comoras",
  "CG": "Congo",
  "CD": "República Democrática del Congo",
  "CK": "Islas Cook",
  "CR": "Costa Rica",
  "CI": "Costa de Marfil",
  "HR": "Croacia",
  "CU": "Cuba",
  "CY": "Chipre",
  "CZ": "República Checa",
  "DK": "Dinamarca",
  "DJ": "Yibuti",
  "DM": "Dominica",
  "DO": "República Dominicana",
  "EC": "Ecuador",
  "EG": "Egipto",
  "SV": "El Salvador",
  "GQ": "Guinea Ecuatorial",
  "ER": "Eritrea",
  "EE": "Estonia",
  "ET": "Etiopía",
  "FK": "Islas Malvinas",
  "FO": "Islas Feroe",
  "FJ": "Fiyi",
  "FI": "Finlandia",
  "FR": "Francia",
  "GF": "Guayana Francesa",
  "PF": "Polinesia Francesa",
  "TF": "Tierras Australes y Antárticas Francesas",
  "GA": "Gabón",
  "GM": "Gambia",
  "GE": "Georgia",
  "DE": "Alemania",
  "GH": "Ghana",
  "GI": "Gibraltar",
  "GR": "Grecia",
  "GL": "Groenlandia",
  "GD": "Granada",
  "GP": "Guadalupe",
  "GU": "Guam",
  "GT": "Guatemala",
  "GG": "Bailía de Guernsey",
  "GN": "Guinea",
  "GW": "Guinea-Bisáu",
  "GY": "Guyana",
  "HT": "Haití",
  "HM": "Islas Heard y McDonald",
  "VA": "Santa Sede (Estado de la Ciudad del Vaticano)",
  "HN": "Honduras",
  "HK": "Hong Kong",
  "HU": "Hungría",
  "IS": "Islandia",
  "IN": "India",
  "ID": "Indonesia",
  "IR": "República Islámica de Irán",
  "IQ": "Irak",
  "IE": "Irlanda",
  "IM": "Isla de Man",
  "IL": "Israel",
  "IT": "Italia",
  "JM": "Jamaica",
  "JP": "Japón",
  "JE": "Bailía de Jersey",
  "JO": "Jordania",
  "KZ": "Kazajistán",
  "KE": "Kenia",
  "KI": "Kiribati",
  "KR": "Corea",
  "KW": "Kuwait",
  "KG": "Kirguistán",
  "LA": "República Democrática Popular Lao",
  "LV": "Letonia",
  "LB": "Líbano",
  "LS": "Lesoto",
  "LR": "Liberia",
  "LY": "Yamahiriya Árabe Libia",
  "LI": "Liechtenstein",
  "LT": "Lituania",
  "LU": "Luxemburgo",
  "MO": "Macao",
  "MK": "Macedonia",
  "MG": "Madagascar",
  "MW": "Malaui",
  "MY": "Malasia",
  "MV": "Maldivas",
  "ML": "Mali",
  "MT": "Malta",
  "MH": "Islas Marshall",
  "MQ": "Martinica",
  "MR": "Mauritania",
  "MU": "Mauricio",
  "YT": "Mayotte",
  "MX": "México",
  "FM": "Estados Federados de Micronesia",
  "MD": "Moldavia",
  "MC": "Mónaco",
  "MN": "Mongolia",
  "ME": "Montenegro",
  "MS": "Montserrat",
  "MA": "Marruecos",
  "MZ": "Mozambique",
  "MM": "Myanmar",
  "NA": "Namibia",
  "NR": "Nauru",
  "NP": "Nepal",
  "NL": "Países Bajos",
  "AN": "Antillas Holandesas",
  "NC": "Nueva Caledonia",
  "NZ": "Nueva Zelanda",
  "NI": "Nicaragua",
  "NE": "Níger",
  "NG": "Nigeria",
  "NU": "Niue",
  "NF": "Isla Norfolk",
  "MP": "Islas Marianas del Norte",
  "NO": "Noruega",
  "OM": "Omán",
  "PK": "Pakistán",
  "PW": "Palau",
  "PS": "Territorio Palestino Ocupado",
  "PA": "Panamá",
  "PG": "Papúa Nueva Guinea",
  "PY": "Paraguay",
  "PE": "Perú",
  "PH": "Filipinas",
  "PN": "Pitcairn",
  "PL": "Polonia",
  "PT": "Portugal",
  "PR": "Puerto Rico",
  "QA": "Catar",
  "RE": "Reunión",
  "RO": "Rumanía",
  "RU": "Federación Rusa",
  "RW": "Ruanda",
  "BL": "San Bartolomé",
  "SH": "Santa Helena",
  "KN": "San Cristóbal y Nieves",
  "LC": "Santa Lucía",
  "MF": "San Martín",
  "PM": "San Pedro y Miquelón",
  "VC": "San Vicente y las Granadinas",
  "WS": "Samoa",
  "SM": "San Marino",
  "ST": "Santo Tomé y Príncipe",
  "SA": "Arabia Saudita",
  "SN": "Senegal",
  "RS": "Serbia",
  "SC": "Seychelles",
  "SL": "Sierra Leona",
  "SG": "Singapur",
  "SK": "Eslovaquia",
  "SI": "Eslovenia",
  "SB": "Islas Salomón",
  "SO": "Somalia",
  "ZA": "Sudáfrica",
  "GS": "Islas Georgias del Sur y Sándwich del Sur",
  "ES": "España",
  "LK": "Sri Lanka",
  "SD": "Sudán",
  "SR": "Surinam",
  "SJ": "Svalbard y Jan Mayen",
  "SZ": "Suazilandia",
  "SE": "Suecia",
  "CH": "Suiza",
  "SY": "República Árabe Siria",
  "TW": "Taiwán",
  "TJ": "Tayikistán",
  "TZ": "Tanzania",
  "TH": "Tailandia",
  "TL": "Timor Oriental",
  "TG": "Togo",
  "TK": "Tokelau",
  "TO": "Tonga",
  "TT": "Trinidad y Tobago",
  "TN": "Túnez",
  "TR": "Turquía",
  "TM": "Turkmenistán",
  "TC": "Islas Turcas y Caicos",
  "TV": "Tuvalu",
  "UG": "Uganda",
  "UA": "Ucrania",
  "AE": "Emiratos Árabes Unidos",
  "GB": "Reino Unido",
  "UM": "Islas Ultramarinas de Estados Unidos",
  "UY": "Uruguay",
  "UZ": "Uzbekistán",
  "VU": "Vanuatu",
  "VE": "Venezuela",
  "VN": "Vietnam",
  "VG": "Islas Vírgenes Británicas",
  "VI": "Islas Vírgenes de los Estados Unidos",
  "WF": "Wallis y Futuna",
  "EH": "Sahara Occidental",
  "YE": "Yemen",
  "ZM": "Zambia",
  "ZW": "Zimbabue"
}
